import { FPAItem } from '../../infra/protected/FPA/FPAItem';

/** Returns the chain from a matching root node down to the item with `key`, or undefined if not found. */
export function findPathToItem(items: FPAItem[], key: string | number): FPAItem[] | undefined {
    for (const item of items) {
        if (+item.id === +key) {
            return [item];
        }
        if (item.childItems?.length) {
            const sub = findPathToItem(item.childItems, key);
            if (sub?.length) {
                return [item, ...sub];
            }
        }
    }
    return undefined;
}
